import PropTypes from '../../_util/vue-types';

export var ITouchProps = {
  disabled: PropTypes.bool,
  activeClassName: PropTypes.string,
  activeStyle: PropTypes.any
  // onTouchStart: PropTypes.func,
  // onTouchEnd: PropTypes.func,
  // onTouchCancel: PropTypes.func,
  // onMouseDown: PropTypes.func,
  // onMouseUp: PropTypes.func,
  // onMouseLeave: PropTypes.func,
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-m-feedback/src/PropTypes.js
// module id = null
// module chunks = 